// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JdrW","toggle":"styles_toggle__330aq","preview":"styles_preview__2bvHV"};